(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfCustomDataMapDownloadFixedTableHeader', [
    '$timeout', '$window', function($timeout, $window) {
      return {
        restrict: 'A',
        link: (function(_this) {
          return function($scope, $elem, $attrs, $ctrl) {
            var debug, fixIt, handle;
            debug = false;
            fixIt = function() {
              $elem.find('thead, tbody').css('display', '');
              return $timeout(function() {
                $elem.find('th').each(function(i, thElem) {
                  var columnWidth, tdElems;
                  thElem = $(thElem);
                  tdElems = $elem.find('tbody tr:first td:nth-child(' + (i + 1) + ')');
                  if (debug) {
                    console.log(thElem);
                  }
                  if (debug) {
                    console.log(tdElems);
                  }
                  columnWidth = tdElems.width();
                  thElem.width(columnWidth);
                  tdElems.width(columnWidth);
                  if (debug) {
                    return console.log(columnWidth);
                  }
                });
                $elem.find('thead').css({
                  display: 'block'
                });
                $elem.find('tbody').css({
                  display: 'block',
                  overflow: 'auto'
                });
                if ($scope.tableHeight) {
                  return $elem.find('tbody').css({
                    height: $scope.tableHeight
                  });
                }
              });
            };
            angular.element($window).bind('resize', debounce(function() {
              return fixIt();
            }));
            _this.previouslyVisible = $elem.find('tbody').is(':visible');
            $scope.$watch(function() {
              return $elem.find('tbody').is(':visible') !== _this.previouslyVisible;
            }, function(resize) {
              if (resize) {
                _this.previouslyVisible = $elem.find('tbody').is(':visible');
                return fixIt();
              }
            });
            if ($attrs.mfFixedHeaderUnholyMapHack != null) {
              handle = debounce(function() {
                fixIt();
                return $timeout(fixIt, 100);
              }, 800);
              App.map.on('resize', handle);
              $scope.$on('$destroy', function() {
                return App.map.off('handle', handle);
              });
            }
            if ($attrs != null ? $attrs.mfCustomDataMapDownloadFixedTableHeader : void 0) {
              return $scope.$watch($attrs.mfCustomDataMapDownloadFixedTableHeader, fixIt);
            }
          };
        })(this)
      };
    }
  ]);

}).call(this);
